import styled from "styled-components";
import ThemeColors from "../../themes/colors";
import ThemeSize from "../../themes/fontSize";

export const StyledTypography = styled.span<{
  size: keyof typeof ThemeSize;
  color: keyof typeof ThemeColors;
  weight: number;
  fontStyle: string;
  textAlign: string;
}>`
  font-size: ${(props) => ThemeSize[props.size]};
  color: ${(props) => ThemeColors[props.color]};
  font-weight: ${(props) => props.weight};
  font-style: ${(props) => props.fontStyle};
  line-height: 1.5rem;
  text-align: ${(props) => props.textAlign};
  letter-spacing: 1.2px;
`;
